import { createRef, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet-async";
import { keyEnter, siteKey } from "../Utils";
import { Button } from "../components/Button";
import FeedbackModal from "../components/FeedbackModal";
import LoginModal from "../components/LoginModal";
import RegisterModal from "../components/RegisterModal";
import { DisplayInfo } from "../contexts/Contexts";
import "../styles/home.css";

function Home() {
  const recaptchaRef = createRef();
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const { isTablet, isPortrait } = useContext(DisplayInfo);

  const [registerOpen, setRegisterOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const linkText = "Report Issue | Help";
  const stacked = isTablet || isPortrait;

  document.body.id = "home";

  useEffect(() => {
    const encodedToken = urlParams.get("token");
    if (encodedToken !== null) return setRegisterOpen(true);

    const action = urlParams.get("action");
    if (action === "sign-in") setLoginOpen(true);
  }, []);

  const buttons = [
    <Button
      key={1}
      id="register-button"
      label="Register"
      variant="secondary"
      fontSize={stacked ? "1.6rem" : "1.4rem"}
      onClick={() => setRegisterOpen(true)}
    />,
    <Button
      key={2}
      id="sign-in-button"
      label="Sign in"
      variant="light"
      fontSize={stacked ? "1.6rem" : "1.4rem"}
      onClick={() => setLoginOpen(true)}
    />,
  ];

  return (
    <>
      <Helmet>
        <title>Welcome | Hazard Perception</title>
      </Helmet>
      <header>Hazard Perception</header>
      <div className="button-group">
        {stacked ? buttons.reverse() : buttons}

        <a
          className="link"
          type="button"
          tabIndex={0}
          onClick={() => setFeedbackOpen(true)}
          onKeyDown={(e) => keyEnter(e, () => setFeedbackOpen(true))}
        >
          {linkText}
        </a>
      </div>

      <RegisterModal state={[registerOpen, setRegisterOpen]} />
      <LoginModal
        state={[loginOpen, setLoginOpen]}
        recaptchaRef={recaptchaRef}
      />
      <FeedbackModal modalState={[feedbackOpen, setFeedbackOpen]} />

      {createPortal(
        <ReCAPTCHA ref={recaptchaRef} sitekey={siteKey} size="invisible" />,
        document.body,
      )}
    </>
  );
}

export default Home;
